<template>
    <div class="activeSet">
        <el-form ref="form" :model="form" label-width="90px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="活动关联">
                <el-switch v-model="form.isrelevent" :active-value=1 :inactive-value=0 :disabled="isEnd"></el-switch>
                <span class="tips magin20">添加直播间活动，提升直播间收益</span>
            </el-form-item>
            <el-form-item v-show="form.isrelevent">
                <el-button type="primary" plain @click="addActive" :disabled="isEnd">+增加直播间活动</el-button>
                <span class="tips magin20">可以添加全民分销、助力砍价、品牌商零售活动。只能增加一个活动</span>
            </el-form-item>
        </el-form>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" class="margin90" style="width: 805px" v-show="form.isrelevent&&tableData.length>0">
                <el-table-column prop="" label="活动名称" class-name="title">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img :src="scope.row.coverurl" alt="">
                            <p>{{scope.row.eventname}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="活动类型" class-name="center" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.jkteventtype==4?'助力砍价':(scope.row.jkteventtype==5?'全民分销':'品牌商零售')}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="address" label="操作" class-name="delText" label-class-name="tr" width="200">
                    <template slot-scope="scope">
                        <span  @click="handleDel(scope.row,scope.$index)" v-if="!isEnd">删除</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
         <el-button type="primary" class="saveBtn" @click="saveEvent" v-if="!isEnd">保存</el-button>
        <!--<el-form-item label="">-->
            <!--<el-button type="primary" class="saveBtn" @click="saveEvent">保存</el-button>-->
        <!--</el-form-item>-->
        <ActiveList ref="activeList" @getTable="_getTable"></ActiveList>
    </div>
</template>

<script>
    import ActiveList from '@/views/vliveV2/components/activeList'
    import {uploadLiveRelEventInfo} from 'api/vliveV2Api'
    import {mapGetters,mapActions} from 'vuex'
    export default {
        name: "activeSet",
        data(){
            return{
                form:{
                    isrelevent:0,
                    jkteventinnerid:'', //活动id
                    jkteventtype :0, //活动类型
                    liveid:'', //直播id
                },
                tableData:[],
                isEnd:false
            }
        },
        mounted(){
            this.form=JSON.parse(JSON.stringify(this.playInfo.eventinfo));
            this.tableData = [];
            if(this.playInfo.eventinfo.jkteventinnerid) {
                this.tableData.push(this.playInfo.eventinfo);
            }
            this.isEnd=[10,100].indexOf(this.liveInfo.status)>=0
        },
        methods:{
            //添加直播间活动
            addActive(){
                this.$refs.activeList.open();
            },
            _getTable(list){
                this.tableData = [];
                this.tableData.push(list);
                this.form.coverurl=list.coverurl;
                this.form.eventname=list.eventname;
                this.form.jkteventinnerid=list.jkteventinnerid;
                this.form.jkteventtype=list.jkteventtype;
                this.setPlayInfo(list)
            },
            //保存
            saveEvent(){
                this.form.liveid=JSON.parse(window.sessionStorage.getItem('liveInfo')).liveid
                if(this.form.isrelevent==1&&!this.form.jkteventinnerid){
                    this.$message({
                        message: '请选择关联活动',
                        type: 'warning'
                    });
                    return
                }else{
                    this.setLoading(true);
                    uploadLiveRelEventInfo({
                        data: Object.assign({}, this.form),
                        success: data => {
                            this.setLoading(false);
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                        },
                        error: data => {
                            this.setLoading(false);
                            this.$message.error(data.msg)
                        }
                    })
                }
            },
            //删除
            handleDel(row,index){
                this.$confirm(`确认删除该活动吗？`, '提示', {
                }).then(() => {
                    this.tableData.splice(index,1);
                    this.form.coverurl='';
                    this.form.eventname='';
                    this.form.jkteventinnerid='';
                    this.form.jkteventtype=0;
                }).catch(() => {})
            },
            ...mapActions([
                'setLoading','setLiveInfo','setPlayInfo'
            ])
        },
        computed: {
            ...mapGetters([
                'liveInfo','playInfo'
            ])
        },
        components: {
            ActiveList
        },
    }
</script>

<style lang="scss">
    .activeSet{
        .tips{
            color: #999;
            font-size: 13px;
        }
        .magin20{
            padding-left: 20px;
        }
        .el-button--primary.is-plain{
            padding: 0 10px;
        }
        /*表格样式*/
        .result-list{
            .margin90{
                margin-left: 90px;
            }
            .el-table::before{
                background: none;
            }
            .el-pagination::after{
                display: none;
            }
            .el-table__row{
                cursor: pointer;
            }
            .imageText{
                display: flex;
                align-items: center;
                img{
                    min-width: 74px;
                    width: 74px;
                    height: 42px;
                    margin-right: 10px;
                }
            }
            .delText{
                .cell{
                    text-align: right;
                    span{
                        color: #409EFF;
                        cursor: pointer;
                    }
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
            /*表格背景色*/
            .el-table__row{
                background: rgba(245,247,250,1);
            }
            /*标题背景色*/
            .el-table th.is-leaf{
                background: rgba(240,242,245,1);
                box-shadow: 0px -1px 0px 0px rgba(228,231,237,1);
            }
        }
        .saveBtn{
            margin-left: 90px;
            margin-top: 20px;
        }
    }
</style>
